import { Spacing, colors, getCdnImageSrc, Image } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

interface HomeV4PriceSectionProps {
  title?: ReactNode;
  description?: ReactNode;
  imageSrc?: string;
}

export default function HomeV4PriceSection({
  title = "상황에 맞는 납입 금액을 선택하세요",
  description = (
    <>
      100원 부터 납입 가능하고
      <br />
      9,900원 이상 납입 시 추가 혜택이 있어요.
    </>
  ),
  imageSrc = "images/package-price/289/prime/table-price-289.png",
}: HomeV4PriceSectionProps) {
  return (
    <BaseStack
      width="100%"
      padding="120px 20px 0px 20px"
      background={colors.white}
      alignItems="center"
    >
      <Box className="subtitle_21_sb" color={colors.gray900} textAlign="center">
        {title}
      </Box>

      <Spacing gap={8} />

      <Box className="body_16_r" color={colors.gray600} textAlign="center">
        {description}
      </Box>

      <Spacing gap={24} />

      <Image
        src={getCdnImageSrc(imageSrc)}
        alt="납입 금액 비교표"
        width="100%"
      />
    </BaseStack>
  );
}
